import { sendSelectListItem } from '~/composables/useGtmEvents'
import { GtmItemListId } from '~/composables/useKftGtm/types'
import type { FederatedSearchAnalyticsPlacement } from '~/utils/searchEngineHelpers'

export const EVENTS_SOURCE_ID = 'events'
const CITY_OR_CATEGORY_SOURCE_IDS = ['locations', 'eventCategories']
// federated-search.css: in the one-column layout (city/category suggestions
// shown next to the events) `.aa-Item:nth-last-child(n + 5)` is hidden, so
// only the LAST 4 event items are visible.
const ONE_COLUMN_VISIBLE_EVENTS = 4

// The homepage banner search and the navbar search (every other page) are
// tracked as separate lists.
export const getFederatedSearchItemListIds = (
  placement?: FederatedSearchAnalyticsPlacement
) =>
  placement === 'homepage'
    ? {
        results: GtmItemListId.FederatedSearchHomepage,
        lastViewed: GtmItemListId.FederatedSearchHomepageLastViewed,
      }
    : {
        results: GtmItemListId.FederatedSearchNavbar,
        lastViewed: GtmItemListId.FederatedSearchNavbarLastViewed,
      }

export const getEventsCollectionItems = (state: any): any[] =>
  state?.collections?.find(
    (collection: any) => collection?.source?.sourceId === EVENTS_SOURCE_ID
  )?.items ?? []

// The event items actually rendered in the panel, mirroring the CSS cap above
export const getVisibleEventItems = (state: any): any[] => {
  const items = getEventsCollectionItems(state)
  const hasCityOrCategoryResults = state?.collections?.some(
    (collection: any) =>
      CITY_OR_CATEGORY_SOURCE_IDS.includes(collection?.source?.sourceId) &&
      collection?.items?.length > 0
  )
  return hasCityOrCategoryResults
    ? items.slice(-ONE_COLUMN_VISIBLE_EVENTS)
    : items
}

// GA4 `select_item` for an event/kit hit picked from the autocomplete panel.
// Called from the events source `onSelect` only: autocomplete-core runs
// `onSelect` for both click and Enter (then `navigator.navigate`), so calling
// it from the navigator too would double-count. Must run before the hard
// navigation so the list attribution is persisted for the rest of the funnel.
export const sendAutocompleteSelectItem = (
  state: any,
  item: any,
  placement?: FederatedSearchAnalyticsPlacement
) => {
  const index = getVisibleEventItems(state).indexOf(item)
  const searchTerm = state?.query?.trim()
  sendSelectListItem(
    getFederatedSearchItemListIds(placement).results,
    [item],
    Math.max(index, 0),
    searchTerm ? { item_search_term: searchTerm } : {}
  )
}
